<div
  snInViewport
  (inViewportChange)="onInViewportChange($event)"
  [inViewportOptions]="viewportOptions"
  class="grid-content"
>
  <ng-container *ngIf="toLoad">
    <div class="chart-section" nz-row nzGutter="8">
      <div class="chart comparative-chart-container" nz-col [nzSpan]="24">
        <div class="chart-title">
          {{
            selectedChartType === chartTypeMapping.comparison
              ? periodLabel[currentIndex]
              : dataToUse["lineInfo"][currentItem]
                ? dataToUse["lineInfo"][currentItem].name
                : ""
          }}
        </div>
        <div *ngIf="chartInstance" class="comparative-chart-download">
          <div
            nz-popover
            nzPopoverTrigger="click"
            [nzPopoverContent]="downloadOptionsTemplate"
            [(nzPopoverVisible)]="downloadOptVisible"
            class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
            [ngClass]="[
              !dataToUse ||
              !dataToUse['tickers'] ||
              !dataToUse['tickers'].length
                ? 'va-button--disabled'
                : ''
            ]"
            nzPopoverPlacement="bottomRight"
            title="Download Chart"
          >
            <va-icon
              size="small"
              name="arrow-to-bottom"
              class="va-button-icon"
            ></va-icon>
          </div>
          <ng-template #downloadOptionsTemplate>
            <div class="download-opt" (click)="downloadValue(4)">
              Print Chart
            </div>
            <hr class="solid" />
            <div (click)="downloadValue(0)" class="download-opt">
              Download PNG
            </div>
            <div (click)="downloadValue(1)" class="download-opt">
              Download JPEG
            </div>
            <div (click)="downloadValue(2)" class="download-opt">
              Download PDF
            </div>
            <div (click)="downloadValue(3)" class="download-opt">
              Download SVG
            </div>
            <hr class="solid" />
            <div (click)="onExport()" class="download-opt">Export Value</div>
          </ng-template>
        </div>
        <div class="chart-plotter-container">
          <app-chart-plotter
            [chartType]="selectedChartType"
            [dataToUse]="dataToUse"
            pageName="industry"
            (onChartInstance)="onChartInstance($event)"
          >
          </app-chart-plotter>

          <div
            class="chart-info"
            class="chart-info"
            *ngIf="chartInfoBottom !== '0px'"
            [ngStyle]="{ bottom: chartInfoBottom }"
          >
            <div
              class="checkbox-sm"
              *ngIf="
                dataToUse &&
                dataToUse['lines'].length > 1 &&
                !isSecondaryAxisUpdateInProgress
              "
            >
              <label
                nz-checkbox
                [(ngModel)]="isSecondaryAxis"
                (ngModelChange)="changeAxis($event)"
                class="checkbox-label"
                [nzDisabled]="!allowCombineAxis"
                >Secondary axis</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="!toLoad" class="grid-placeholder">
  <div nz-menu>
    <div
      *ngFor="let dummySection of [0, 1, 2, 3]"
      style="padding: 0px 15px 0px 15px"
    >
      <nz-skeleton
        [nzTitle]="true"
        [nzActive]="true"
        [nzParagraph]="false"
      ></nz-skeleton>
    </div>
  </div>
</div>
